<template>
  <div class="page" :class="pageSizeClass">
    <!-- 상단 커버 이미지 (작은 버전) 
    <div class="cover-image-section">
      <img
        class="cover-image"
        src="@/assets/cover/281_in.png"
        alt="Cover Image"
      />
    </div>
-->
    <!-- 학회 정보 -->
    <div class="society-info-section">
      <img
        class="society-logo"
        src="@/assets/cover/iskal_logo_in.png"
        alt="ISKAL Logo"
      />
      <div class="society-text">
        <p class="society-name-en">
          The International Society of Korean Applied Linguistics
        </p>
        <p class="society-name-ko">국제한국어응용언어학회</p>
      </div>
    </div>

    <!-- 구분선 -->
    <hr class="divider" />

    <!-- 임원 정보 -->
    <div class="committee-section">
      <div class="committee-group" v-if="innerBackData.advisory_committee">
        <p class="committee-title">Advisory Committee</p>
        <p
          class="committee-member"
          v-for="(member, idx) in parseMembers(innerBackData.advisory_committee)"
          :key="'ac-' + idx"
        >{{ member }}</p>
      </div>

      <div class="committee-group" v-if="innerBackData.president">
        <p class="committee-title">President</p>
        <p
          class="committee-member"
          v-for="(member, idx) in parseMembers(innerBackData.president)"
          :key="'pr-' + idx"
        >{{ member }}</p>
      </div>

      <div class="committee-group" v-if="innerBackData.vice_president">
        <p class="committee-title">Vice President</p>
        <p
          class="committee-member"
          v-for="(member, idx) in parseMembers(innerBackData.vice_president)"
          :key="'vp-' + idx"
        >{{ member }}</p>
      </div>

      <div class="committee-group" v-if="innerBackData.secretary_general">
        <p class="committee-title">Secretary General</p>
        <p
          class="committee-member"
          v-for="(member, idx) in parseMembers(innerBackData.secretary_general)"
          :key="'sg-' + idx"
        >{{ member }}</p>
      </div>

      <div class="committee-group" v-if="innerBackData.general_affairs">
        <p class="committee-title">General Affairs</p>
        <p
          class="committee-member"
          v-for="(member, idx) in parseMembers(innerBackData.general_affairs)"
          :key="'ga-' + idx"
        >{{ member }}</p>
      </div>

      <div class="committee-group" v-if="innerBackData.research_planning">
        <p class="committee-title">Research Planning</p>
        <p class="committee-member">{{ innerBackData.research_planning }}</p>
      </div>

      <div class="committee-group" v-if="innerBackData.information">
        <p class="committee-title">Information</p>
        <p class="committee-member">{{ innerBackData.information }}</p>
      </div>

      <div class="committee-group" v-if="innerBackData.editing">
        <p class="committee-title">Editing</p>
        <p class="committee-member">{{ innerBackData.editing }}</p>
      </div>

      <div class="committee-group" v-if="innerBackData.public_information">
        <p class="committee-title">Public Information</p>
        <p class="committee-member">{{ innerBackData.public_information }}</p>
      </div>

      <div class="committee-group" v-if="innerBackData.public_relations">
        <p class="committee-title">Public Relations</p>
        <p
          class="committee-member"
          v-for="(member, idx) in parseMembers(innerBackData.public_relations)"
          :key="'prl-' + idx"
        >{{ member }}</p>
      </div>

      <!--div class="committee-group mt-4" v-if="innerBackData.editorial_board">
        <p class="committee-title">Editorial Board</p>
        <p class="committee-member">{{ innerBackData.editorial_board }}</p>
      </div-->
    </div>
  </div>
</template>

<script>
export default {
  name: "article-inner-cover-back",
  props: {
    group: {
      type: Object,
      required: false,
      default: () => {},
    },
    journal: {
      type: Object,
      required: false,
      default: () => {},
    },
    pageSize: {
      type: String,
      required: false,
      default: "A5",
    },
  },
  computed: {
    pageSizeClass() {
      return this.pageSize?.toLowerCase() || "a5";
    },
    innerBackData() {
      if (this.journal?.inner_back_info) {
        try {
          return JSON.parse(this.journal.inner_back_info);
        } catch (e) {
          return this.defaultData;
        }
      }
      return this.defaultData;
    },
    defaultData() {
      return {
        advisory_committee: "Kim, Namkil(University of Southern California)\nShin, Gihyun(University of New South Wales)\nLee, Gilwon(Dong-A University)\nSong, Hyangkeun(Busan University of Foreign Studies)\nBae, Jaesuk(Kyung Hee University)",
        president: "Kang, Hyounhwa(Yonsei University)",
        vice_president: "Kim, Kyungho(Mejiro University)\nLee, SangHyeok(Hansung University)\nKim, Jeongnam(Kyung Hee University)\nYun, Young(Honam University)\nPark, Seokjoon(Paichai University)\nChoi, Jaejoon(Gachon University)",
        secretary_general: "Hong, Hyeran(Paichai University)",
        general_affairs: "김유미(서울과학종합대학원대학교)\n장미경(성신여대)\n홍연정(오사카공립대)\n심란희(배재대)",
        research_planning: "김양진(경희대), 조참훈(서남대), 도원영(고려대)",
        information: "장준영(숭실사이버대), Kim, Ilhwan(Sungshin Women's University), 전소희(메지로대), 이호은(청운대)",
        editing: "Kim, Kanghee(Yonsei University), 조영보(메지로대), 강은지(부산대), 김의영(한밭대)",
        public_information: "이봉원(나사렛대), 김석영(한국교원대), 박진완(교토 Sanyo University), 유방혜숙(조지메이슨대)",
        public_relations: "이문화(중국화중사범대), 괵셀 튀르괴쥬(에르지예스대), 김선아(이공대), 김찬회(리쓰케이칸 아시아 태평양대), 김선효(문화대),\n두루소(카포스카리 아메리칸대), 장석배(벤더빌트대), 안나 파라돕스카(바르샤바대), 한넬리(아블라이칸대), 신문경(리치몬드 아메리칸대)",
        editorial_board: "Kim, Kanghee(Yonsei University), 조영보(메지로대), 강은지(부산대), 김의영(한밭대)",
      };
    },
  },
  methods: {
    parseMembers(text) {
      if (!text) return [];
      return text.split("\n").filter((m) => m.trim());
    },
  },
};
</script>

<style lang="scss" scoped>
$primary-font-color: #231815;
$secondary-font-color: #666666;
$background-color: #ffffff;

// A4 패딩
$a4-vertical-padding: 50px;
$a4-horizontal-padding: 60px;

// A5 패딩
$a5-vertical-padding: 35px;
$a5-horizontal-padding: 40px;

$sans-font-family: "Sandoll GtNeoCond", "Noto Sans KR", sans-serif;

$a4-width: 794px;
$a4-height: 1122px;
$a5-width: 559px;
$a5-height: 794px;

.page {
  background-color: $background-color;
  position: relative;
  box-sizing: border-box;
  height: auto;
  overflow: visible;
  page-break-before: always;
  page-break-after: always;

  &.a4 {
    width: $a4-width;
    min-height: $a4-height;
    padding: $a4-vertical-padding $a4-horizontal-padding;

    .cover-image-section {
      margin-bottom: 30px;
    }

    .cover-image {
      max-height: 180px;
    }

    .society-info-section {
      gap: 15px;
      margin-bottom: 20px;
    }

    .society-logo {
      width: 100px;
    }

    .society-name-en {
      font-size: 11px;
    }

    .society-name-ko {
      font-size: 14px;
    }

    .divider {
      margin: 20px 0;
    }

    .committee-group {
      margin-bottom: 8px;
    }

    .committee-title {
      font-size: 9px;
    }

    .committee-member {
      font-size: 9px;
    }
  }

  &.a5 {
    width: $a5-width;
    min-height: $a5-height;
    padding: $a5-vertical-padding $a5-horizontal-padding;

    .cover-image-section {
      margin-bottom: 20px;
    }

    .cover-image {
      max-height: 120px;
    }

    .society-info-section {
      gap: 10px;
      margin-bottom: 15px;
    }

    .society-logo {
      width: 70px;
    }

    .society-name-en {
      font-size: 8px;
    }

    .society-name-ko {
      font-size: 10px;
    }

    .divider {
      margin: 12px 0;
    }

    .committee-group {
      margin-bottom: 5px;
    }

    .committee-title {
      font-size: 7px;
    }

    .committee-member {
      font-size: 7px;
      line-height: 1.3;
    }

    .mt-4 {
      margin-top: 10px;
    }
  }
}

/** ****************************************************************************************
 * [ 커버 이미지 섹션 ]
 *******************************************************************************************/
.cover-image-section {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
}

.cover-image {
  width: 100%;
  height: auto;
  max-height: 180px;
  object-fit: cover;
}

/** ****************************************************************************************
 * [ 학회 정보 섹션 ]
 *******************************************************************************************/
.society-info-section {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
}

.society-logo {
  width: 100px;
  height: auto;
}

.society-text {
  display: flex;
  flex-direction: column;
}

.society-name-en {
  font-family: $sans-font-family;
  font-size: 11px;
  font-weight: 600;
  color: $primary-font-color;
  text-align: left;
  margin: 0;
}

.society-name-ko {
  font-family: $sans-font-family;
  font-size: 14px;
  font-weight: 700;
  color: $primary-font-color;
  text-align: left;
  margin: 0;
}

/** ****************************************************************************************
 * [ 구분선 ]
 *******************************************************************************************/
.divider {
  border: none;
  border-top: 1px solid $primary-font-color;
  margin: 20px 0;
}

/** ****************************************************************************************
 * [ 임원 정보 섹션 ]
 *******************************************************************************************/
.committee-section {
  padding: 0;
}

.committee-group {
  margin-bottom: 8px;
}

.committee-title {
  font-family: $sans-font-family;
  font-size: 9px;
  font-weight: 700;
  color: $primary-font-color;
  margin: 0 0 2px 0;
}

.committee-member {
  font-family: $sans-font-family;
  font-size: 9px;
  font-weight: 400;
  color: $primary-font-color;
  margin: 0;
  line-height: 1.4;
}

.mt-4 {
  margin-top: 16px;
}
</style>
